// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n.btn-scroll-top[data-v-60a65138]{\n  width:50px;\n  height:50px;\n  outline:none!important\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
